module.exports = __webpack_public_path__ + "img/checkright.8feaf7bf.svg";